import React from 'react';
import './list-display.scss';
import { observer } from 'mobx-react-lite';
import { PolicySummaryPanelData } from './policy-summary-utils';


const ThreatsContent: React.FC<{data: PolicySummaryPanelData}> = observer(({ data }) => {

    return <>
        {data.summaries.map(_ => <div key={_} className={'summary-item'}>{_}</div>)}
    </>;
});

export default ThreatsContent;